<template>
    <div class="block">
        <custom-navbar v-model="active" fixed padding-scroll shadow>
            <template #left>
                <app-button
                    circle
                    icon
                    color="brand-blue"
                    size="xl"
                    class="ml-1 md:ml-2"
                    @click="UPDATE_SIDEBAR_STATE(!activeSidebar)"
                >
                    <img
                        src="@/assets/images/hamburger.svg"
                        height="20"
                        width="20"
                        alt="open menu"
                    />
                </app-button>

                <router-link to="/app" aria-label="Inicio">
                    <picture>
                        <source
                            srcset="/img/logos/complete_logo.png"
                            class="h-10 w-auto"
                            width="180"
                            height="113"
                            media="(min-width:900px)"
                            x-content-type-options="nosniff"
                        />
                        <img
                            src="/img/logos/logo.png"
                            :alt="`Icono ${$siteTitle}`"
                            :title="`Icono ${$siteTitle}`"
                            class="h-10 w-auto"
                        />
                    </picture>
                </router-link>
            </template>
            <merchant-modal-selector class="lg:hidden" />
            <template #right>
                <div class="flex w-full justify-end items-center">
                    <merchant-modal-selector class="hidden lg:block px-1" />
                    <bell-notifications />
                    <options-user
                        v-if="$data.$showUserMenu"
                        class="lg:ml-4 ml-2 mr-1"
                    />
                </div>
            </template>
        </custom-navbar>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import { ENABLED_AUTH } from "@/common/constants";

import MerchantModalSelector from "../merchants/MerchantModalSelector.vue";
import BellNotifications from "../notifications/BellNotifications.vue";
import OptionsUser from "./OptionsUser.vue";

export default {
    name: "NavbarApp",
    components: { OptionsUser, MerchantModalSelector, BellNotifications },
    data: () => ({
        active: true,
        $showUserMenu: ENABLED_AUTH
    }),
    computed: {
        ...mapState("control", ["activeSidebar"])
    },
    methods: {
        ...mapMutations("control", ["UPDATE_SIDEBAR_STATE"])
    }
};
</script>
